import React from "react";
import { Stack } from "react-bootstrap";
import { useLocation, useParams } from "react-router";
import { Link } from "react-router-dom";

import useBreakpoint from "@hooks/useBreakpoint";

import { isXOrSmaller } from "@lib/utils";

const Sidebar = (): React.JSX.Element => {
    const params = useParams();
    const breakpoint = useBreakpoint();
    const location = useLocation();
    const pathMatch = /playoffs/.test(location.pathname);
    const isOnTeamPage = /teams/.test(location.pathname);
    const isOnTeamSchedulePage = /teams.*schedule/.test(location.pathname);

    return (
        <Stack
            gap={2}
            direction={
                pathMatch
                    ? isXOrSmaller("lg", breakpoint)
                        ? "horizontal"
                        : "vertical"
                    : isXOrSmaller("md", breakpoint)
                      ? "horizontal"
                      : "vertical"
            }
            className="leagueSidebar"
        >
            {isOnTeamSchedulePage && (
                <Link
                    to={`/leagues/${params.leagueId}/teams/${params.teamId}`}
                    className="btn btn-primary"
                >
                    Team Home
                </Link>
            )}
            {isOnTeamPage && (
                <Link
                    to={`/leagues/${params.leagueId}/teams/${params.teamId}/schedule`}
                    className="btn btn-primary"
                >
                    Team Schedule
                </Link>
            )}
            <Link
                to={`/leagues/${params.leagueId}`}
                className="btn btn-primary"
            >
                League Standings
            </Link>
            <Link
                to={`/leagues/${params.leagueId}/playoffs`}
                className="btn btn-primary"
            >
                League Playoff Bracket
            </Link>
            <Link
                to={`/leagues/${params.leagueId}/schedule`}
                className="btn btn-primary"
            >
                League Schedule
            </Link>
        </Stack>
    );
};

export default Sidebar;
